<div class="OrganizationSwitcher u-spacing-lg-pt u-spacing-md-pb">
    <div class="u-spacing-lg-ph" [ngClass]="{ 'u-spacing-md-pb u-border-bottom-secondary': hasOrgsToImpersonate() }">
        <div class="flex-row flex-middle flex-start flex-nowrap">
            <div class="flex-col u-spacing-sm-mr">
                <ce-name-display [hideName]="true" [name]="organisationName()" />
            </div>
            <div class="flex-col flex-start u-text-truncate u-spacing-xs-mr">
                <span class="u-text-action-md"> {{ organisationName() }} </span>
            </div>

            @if (!isImpersonating()) {
            <div class="flex-col">
                <span class="u-text-label-xs u-color-text-secondary">Home</span>
            </div>
            }
        </div>

        <div class="flex-row flex-middle u-spacing-sm-mt">
            @if( licenseName()) {
            <span class="u-text-body-xs">{{ licenseName() }}</span>

            } @if (roleDisplay()) {
            <span class="u-spacing-sm-mh u-color-text-secondary">&#8226;</span>
            <span class="u-text-body-xs u-spacing-xs-mr u-color-text-secondary">User role</span>
            <span class="u-text-body-xs">
                {{ roleDisplay() }}
            </span>
            @if (roleToolTipMessage()) {
            <ce-icon ce-icon-xs class="u-spacing-2xs-ml" ceTooltip="{{ roleToolTipMessage() }}" [svgIcon]="'info'"></ce-icon>
            }}
        </div>

        <div *ceIfFeature="'FEATURE_ACCESS_MANAGEMENT'" class="u-spacing-md-mt">
            <button ce-button-small ce-button-type-tertiary type="button" class="OrganizationSwitcher-settingsBtn" (click)="navigateToOrgSettings()">
                Organization settings
            </button>
        </div>
    </div>
    @if(hasOrgsToImpersonate()){
    <div class="OrganizationSwitcher-content u-spacing-lg-ph u-spacing-sm-pb u-spacing-md-pt">
        <span class="u-text-label-xs u-color-text-secondary">Switch organization</span>
    </div>

    <div class="flex-col">
        <ce-list size="sm">
            @if (isImpersonating()) {
            <ce-list-option [disabled]="impersonationUpdating()" onkeypress class="OrganizationSwitcher-organization-item" (click)="changeToHomeOrganization()">
                @if (impersonationUpdating()){
                <ce-spinning-loader-sm ce-list-option-prefix />
                } @else {
                <ce-name-display ce-list-option-prefix [hideName]="true" [name]="homeOrganisationName()" />
                }
                <span ce-list-option-title class="u-text-action-md">{{ homeOrganisationName() }}</span>
                <div ce-list-option-suffix class="u-text-label-xs u-color-text-secondary">Home</div>
            </ce-list-option>
            } @for (item of organisationListComputed(); track item ) {
            <ce-list-option onkeypress [disabled]="impersonationUpdating()" class="OrganizationSwitcher-organization-item" (click)="changeSelection(item)">
                <ce-name-display ce-list-option-prefix [hideName]="true" [name]="item.name" />
                <span ce-list-option-title class="u-text-action-md">{{ item.name }}</span>
            </ce-list-option>
            }
            <ce-list-option onkeypress [disabled]="impersonationUpdating()" class="OrganizationSwitcher-organization-item" (click)="openOrgSwitcherDialog()">
                <ce-icon [svgIcon]="'search'" ce-list-option-prefix></ce-icon>
                <span ce-list-option-title class="u-text-action-md">Search all</span>
            </ce-list-option>
        </ce-list>
    </div>
    }
</div>
